import React from 'react';


const ResumoSection: React.FC<{titulo: string, texto: string, imagem: string}> = ({titulo, texto, imagem}) => {
    return (
        <section className='py-8'>
            <div className="max-w-screen-lg mx-auto px-4 grid md:grid-cols-2 gap-6 items-center">
                <img src={imagem} alt="Lorem ipsum dolor sit" className='max-w-64 md:max-w-80 w-full h-auto rounded-3xl justify-self-center' />

                <div className='text-center md:text-left'>
                    <h3 className="font-semibold text-2xl">
                        {titulo}
                    </h3>

                    <div className='mt-6 text-sm 2xl:text-base' dangerouslySetInnerHTML={{ __html: texto }} />
                </div>
            </div>
        </section>
    );
};

export default ResumoSection;